// Redux slice for managing syllabus UI state.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface SyllabusState {
  isCreateSubjectDrawerOpen: boolean
  selectedStandardFilter: number | null
}

const initialState: SyllabusState = {
  isCreateSubjectDrawerOpen: false,
  selectedStandardFilter: null,
}

const syllabusSlice = createSlice({
  name: 'syllabus',
  initialState,
  reducers: {
    openCreateSubjectDrawer(state, action: PayloadAction<number | undefined>) {
      state.isCreateSubjectDrawerOpen = true
      state.selectedStandardFilter = action.payload ?? null
    },
    closeCreateSubjectDrawer(state) {
      state.isCreateSubjectDrawerOpen = false
    },
    setStandardFilter(state, action: PayloadAction<number | null>) {
      state.selectedStandardFilter = action.payload
    },
  },
})

export const {
  openCreateSubjectDrawer,
  closeCreateSubjectDrawer,
  setStandardFilter,
} = syllabusSlice.actions

export default syllabusSlice.reducer
